// extracted by mini-css-extract-plugin
module.exports = {"searchbox-wrapper":"_1OMEz"};